import React from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

/** 포트폴리오 상세 > 성장정보 > 투자 성장률 스켈레톤*/
const InvestGrowthSummarySkeleton = () => {
  return (
    <>
      <div css={[titleStyle, { gap: '15px' }]}>
        <Skeleton variant="text" width={90} />
        <div css={divider} />
        <div css={date}>
          <Skeleton variant="text" width={150} />
        </div>
      </div>

      <Skeleton
        variant="rectangular"
        height={110}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
          marginBottom: '40px',
        }}
      />
    </>
  );
};

export default InvestGrowthSummarySkeleton;

const divider = css`
  width: 2px;
  height: 18px;
  background-color: #d9d9d9;
`;

const date = css`
  color: ${palette.gray5};
  font-weight: 500;
`;
